import { App, CreateAppOutput, CreateAppPayload, GetAppsParams, UpdateAppPayload } from '../../dto/App';
import { baseApiWithCompanyId } from 'src/redux/services/baseApi';

export const appsApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    getApps: builder.query<{ items: App[]; total: number; filters: GetAppsParams }, GetAppsParams>({
      query: (params) => ({
        url: '/v2/apps',
        params: {
          ...params,
          search: params.search || undefined,
        },
      }),
      providesTags: ['Apps'],
    }),
    createApp: builder.mutation<CreateAppOutput, CreateAppPayload>({
      query(data) {
        return {
          url: `/v2/apps`,
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['Apps'],
    }),
    updateApp: builder.mutation<App, UpdateAppPayload>({
      query(data) {
        return {
          url: `/v2/apps`,
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['Apps'],
    }),
  }),
});

export const { useGetAppsQuery, useCreateAppMutation, useUpdateAppMutation } = appsApi;
